module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_marco_comida_26.48d1bc1d.png";